(() => {
  function closeOverlay(event) {
    event.target.closest('.product-card__overlay').hidden = true;
  }

  function openOverlay(event) {
    const target = event.target.closest('.product-card__overlay-button--open') || evt.target;

    if (!target.dataset.target) {
      return;
    }

    document.querySelector(target.dataset.target).hidden = false;
  }

  function addListeners() {
    document.querySelectorAll('.product-card__overlay-button--close:not([data-initialized="true"])').forEach((button) => {
      button.dataset.initialized = 'true';
      button.addEventListener('click', closeOverlay);
    });

    document.querySelectorAll('.product-card__overlay-button--open:not([data-initialized="true"])').forEach((button) => {
      button.dataset.initialized = 'true';
      button.addEventListener('click', openOverlay);
    });
  };

  document.addEventListener('shopify:recommendations:loaded', addListeners);

  addListeners();
})();